import { Box, Link } from '@amzn/awsui-components-core';
import { CodeLink } from '@amzn/awscat-pattern-library-service-model';
import React, { FunctionComponent } from 'react';

interface Props {
  codeLink: CodeLink;
  isAllowedToSeeAppSecLink: boolean;
}

const CodeRepoItem: FunctionComponent<Props> = ({ codeLink, isAllowedToSeeAppSecLink }: Props) => {
  const renderDetailInfo = () => {
    if (!isAllowedToSeeAppSecLink) {
      return null;
    }
    return (
      <>
        {codeLink.appsecTicket && (
          <div>
            <Link fontSize="body-s" external href={codeLink.appsecTicket}>
              AppSec Security Guidance for AWS Content ticket
            </Link>
          </div>
        )}
        <div>{codeLink.appsecTicket && codeLink.appsecStatus}</div>
        {codeLink.openSourceTicket && (
          <div>
            <Link fontSize="body-s" external href={codeLink.openSourceTicket}>
              Open source ticket
            </Link>
          </div>
        )}
        <div>{codeLink.openSourceTicket && codeLink.openSourceStatus}</div>
      </>
    );
  };

  return (
    <Box
      className={'code-repo-item-detail'}
      margin={{ bottom: 'xxs' }}
      color="text-body-secondary"
      fontSize="body-s"
    >
      <Link fontSize="body-s" external href={codeLink.url}>
        {codeLink.label ? codeLink.label : codeLink.url}
      </Link>
      {codeLink.branch && <div>{`Branch: ${codeLink.branch}`}</div>}
      {renderDetailInfo()}
    </Box>
  );
};

export default CodeRepoItem;
